import * as React from 'react';
type Props = {
  className?: string;
};
export function Youtube({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-Youtube"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.5125 7.60208V7.5625C23.3806 6.70486 23.0507 5.88681 22.5229 5.1875L22.5493 5.22708C21.916 4.59375 21.0583 4.2375 20.1611 4.2375C16.8625 4 11.875 4 11.875 4C11.875 4 6.8875 4 3.5625 4.2375H3.53611C2.63889 4.25069 1.78125 4.62014 1.16111 5.26667L1.17431 5.25347C0.659722 5.96597 0.343056 6.78403 0.224306 7.65486L0.263889 7.36458C0.11875 8.60486 0.0263889 9.85833 0 11.1118V13.2493V12.959C0 14.2125 0.0659722 15.466 0.197917 16.7063L0.2375 17.1285C0.369444 17.9861 0.699306 18.8042 1.22708 19.5035L1.17431 19.4375C1.88681 20.084 2.82361 20.4535 3.78681 20.4667C5.72639 20.6514 11.9014 20.7042 11.9014 20.7042C11.9014 20.7042 16.8889 20.7042 20.2139 20.4535H20.2403C21.1375 20.4403 21.9951 20.0708 22.6153 19.4243L22.6021 19.4375C23.1167 18.725 23.4333 17.9069 23.5521 17.0361V16.9569C23.684 15.7035 23.75 14.45 23.75 13.1965V11.4417V11.7319C23.75 10.4785 23.684 9.225 23.5521 7.98472L23.5125 7.60208ZM9.61896 15.2422V9.09361L15.5433 12.1811L9.61896 15.2422Z"
        fill="black"
      />
      <mask
        id="mask0_109_65"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={4}
        width={24}
        height={17}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.5125 7.60208V7.5625C23.3806 6.70486 23.0507 5.88681 22.5229 5.1875L22.5493 5.22708C21.916 4.59375 21.0583 4.2375 20.1611 4.2375C16.8625 4 11.875 4 11.875 4C11.875 4 6.8875 4 3.5625 4.2375H3.53611C2.63889 4.25069 1.78125 4.62014 1.16111 5.26667L1.17431 5.25347C0.659722 5.96597 0.343056 6.78403 0.224306 7.65486L0.263889 7.36458C0.11875 8.60486 0.0263889 9.85833 0 11.1118V13.2493V12.959C0 14.2125 0.0659722 15.466 0.197917 16.7063L0.2375 17.1285C0.369444 17.9861 0.699306 18.8042 1.22708 19.5035L1.17431 19.4375C1.88681 20.084 2.82361 20.4535 3.78681 20.4667C5.72639 20.6514 11.9014 20.7042 11.9014 20.7042C11.9014 20.7042 16.8889 20.7042 20.2139 20.4535H20.2403C21.1375 20.4403 21.9951 20.0708 22.6153 19.4243L22.6021 19.4375C23.1167 18.725 23.4333 17.9069 23.5521 17.0361V16.9569C23.684 15.7035 23.75 14.45 23.75 13.1965V11.4417V11.7319C23.75 10.4785 23.684 9.225 23.5521 7.98472L23.5125 7.60208ZM9.61896 15.2422V9.09361L15.5433 12.1811L9.61896 15.2422Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_109_65)" />
    </svg>
  );
}
